import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1807.09271,1482.47718 L1886.82918,1562.43953 L1531.51624,1917.75247 L355.346824,1917.75247 L0.0338823529,1562.43953 L79.8832941,1482.47718 L402.104471,1804.81129 L1484.75859,1804.81129 L1807.09271,1482.47718 Z M997.677176,-0.0338823529 L997.677176,1166.98729 L1352.99012,811.674353 L1432.95247,891.523765 L941.093647,1383.15671 L449.460706,891.523765 L529.423059,811.674353 L884.736,1166.98729 L884.736,-0.0338823529 L997.677176,-0.0338823529 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDownloadLine = /*#__PURE__*/function (_Component) {
  _inherits(IconDownloadLine, _Component);

  var _super = _createSuper(IconDownloadLine);

  function IconDownloadLine() {
    _classCallCheck(this, IconDownloadLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconDownloadLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDownload",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconDownloadLine.displayName = "IconDownloadLine";
  return IconDownloadLine;
}(Component);

IconDownloadLine.glyphName = 'download';
IconDownloadLine.variant = 'Line';
IconDownloadLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDownloadLine;
export { IconDownloadLine };